module.exports = __webpack_public_path__ + "7ba1e0f8a6ce00602882389d3381bb99.svg";